import { render, staticRenderFns } from "./ReportSpecialistRating.vue?vue&type=template&id=849c212e&scoped=true"
import script from "./ReportSpecialistRating.vue?vue&type=script&lang=js"
export * from "./ReportSpecialistRating.vue?vue&type=script&lang=js"
import style0 from "@/assets/scss/_appointment-report.scss?vue&type=style&index=0&prod&lang=scss&external"
import style1 from "./ReportSpecialistRating.vue?vue&type=style&index=1&id=849c212e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "849c212e",
  null
  
)

export default component.exports